import React, { useState, useEffect } from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Dropdown } from "react-bootstrap";
import { CancelRequest } from "../../services/AxiosInstance";
import Block from "../../components/Block/Block";
import { Icon } from "../../components";
import { FaTableCellsLarge } from "react-icons/fa6";
import { CiGrid42 } from "react-icons/ci";
import { CustomTooltip } from "../../components/CustomTooltip";
import AssetTableView from "./AssetTableView";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import AssetGridView from "./AssetGridView";
import {
  searchcategoryOptionApi,
  SearchLocationApi,
} from "../../services/SearchService";
import { AllAssetApi } from "../../services/AssetService";
import { toast } from "react-toastify";
import AssetAddModal from "./ActionModal/AssetAddModal";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import { unitStatusOption } from "../../utilities";
function AssetListPage({ userRole }) {
  // const { type } = useParams();
  const [searchParam, setSearchParam] = useSearchParams();
  const [getLoading, setGetLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [dropdownCategory, setDropdownCategory] = useState(null);
  const [dropdownCategoryOption, setDropdownCategoryOption] = useState([]);
  const [dropdownSubCategory, setDropdownSubCategory] = useState(null);
  const [dropdownSubCategoryOption, setDropdownSubCategoryOption] = useState(
    []
  );
  const [filteredSubcategoryOptiions, setFilteredSubCategoryOptions] = useState(
    []
  );
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [locationOption, setLocationOption] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [param, setParam] = useState({
    location: searchParam.get("location") || "",
    category_id: searchParam.get("category_id") || "",
    page: searchParam.get("page") || "1",
    page_size: searchParam.get("page_size") || "10",
    status: searchParam.get("status") || "",
  });
  const getAllLocation = () => {
    SearchLocationApi()
      .then((res) => {
        setLocationOption(res?.data?.results || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAllAsset = () => {
    const { location, ...rest } = param;
    setGetLoading(true);
    AllAssetApi(userRole == "ADMIN" ? param : rest)
      .then((res) => {
        setErrorMsg("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setErrorMsg(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setGetLoading(false);
      });
  };
  useEffect(() => {
    const urlParam = new URLSearchParams(param);
    setSearchParam(urlParam);
    getAllAsset();
  }, [param]);

  useEffect(() => {
    if (!dropdownCategoryOption.length) return;
    const selectedStatusFromUrl = unitStatusOption.find(
      (opt) => opt.value === param.status
    );
    if (selectedStatusFromUrl?.value !== selectedStatus?.value) {
      setSelectedStatus(selectedStatusFromUrl || null);
    }

    const selecetdCategoryFromUrl = dropdownCategoryOption.find(
      (item) => item.value === param.category_id
    );
    if (selecetdCategoryFromUrl?.value !== dropdownCategory?.value) {
      setDropdownCategory(selecetdCategoryFromUrl);
      const filtered = selecetdCategoryFromUrl
        ? dropdownSubCategoryOption.filter(
            (sub) => sub.categoryId === selecetdCategoryFromUrl.value
          )
        : dropdownSubCategoryOption;

      setFilteredSubCategoryOptions(filtered);
    }
  }, [param.status, param.category_id, dropdownCategoryOption]);

  useEffect(() => {
    searchcategoryOptionApi()
      .then((res) => {
        if (res?.data?.results) {
          const categoryOpts = res.data.results.map((item) => ({
            label: item.name,
            value: item.id,
            subcategories: item.subcategories || [],
          }));
          setDropdownCategoryOption(categoryOpts);

          const allSubCats = categoryOpts.flatMap((cat) =>
            cat.subcategories.map((sub) => ({
              label: sub.name,
              value: sub.id,
              categoryId: cat.value,
            }))
          );

          setDropdownSubCategoryOption(allSubCats);
          setFilteredSubCategoryOptions(allSubCats);
        }
      })
      .catch((err) => console.error("Category fetch failed:", err));

    if (userRole == "ADMIN") {
      getAllLocation();
    }
  }, []);

  const handleCategoryChange = (selected) => {
    setDropdownCategory(selected);
    setDropdownSubCategory(null);
    setParam({
      ...param,
      category_id: selected?.value || "",
      sub_category_id: "",
    });

    const filtered = selected
      ? dropdownSubCategoryOption.filter(
          (sub) => sub.categoryId === selected.value
        )
      : dropdownSubCategoryOption;

    setFilteredSubCategoryOptions(filtered);
  };

  const handleSubCategoryChange = (selected) => {
    setDropdownSubCategory(selected);

    if (!selected) {
      setParam({
        ...param,
        sub_category_id: "",
      });
      return;
    }

    const relatedCat =
      dropdownCategory && selected.categoryId === dropdownCategory.value
        ? dropdownCategory
        : dropdownCategoryOption.find(
            (cat) => cat.value === selected.categoryId
          );

    if (
      relatedCat &&
      (!dropdownCategory || relatedCat.value !== dropdownCategory.value)
    ) {
      setDropdownCategory(relatedCat);

      const filtered = dropdownSubCategoryOption.filter(
        (sub) => sub.categoryId === relatedCat.value
      );
      setFilteredSubCategoryOptions(filtered);
    }

    setParam({
      ...param,
      category_id: relatedCat?.value || "",
      sub_category_id: selected?.value || "",
    });
  };

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleDropdownChange = (key, value) => {
    if (param[key] !== value) {
      setParam((prev) => ({
        ...prev,
        [key]: value,
        page: 1,
      }));
    }
  };

  return (
    <div>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2" className="text-primary">
              Assets
            </Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Assets List
                </li>
              </ol>
            </nav>
          </Block.HeadContent>

          <Block.HeadContent>
            <ul className="d-flex">
              {/* <li>
                <Button
                  className="d-md-inline-flex"
                  variant="primary"
                  onClick={() => setAssetModal(true)}
                >
                  <Icon name="plus" />
                  <span>Add Asset</span>
                </Button>
              </li> */}
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>
      <Block>
        <div className="card p-3 mb-2">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-1">
            <div className="flex-grow-1 flex-md-grow-0">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
            <div className="d-flex gap-2 align-items-center flex-wrap">
              <GlobalSearchableDropdown
                options={dropdownCategoryOption}
                selected={dropdownCategory}
                onSelect={(item) => handleCategoryChange(item)}
                placeholder="Category"
              />
              <GlobalSearchableDropdown
                options={filteredSubcategoryOptiions}
                selected={dropdownSubCategory}
                onSelect={(item) => handleSubCategoryChange(item)}
                placeholder="Sub-Category"
              />
              <GlobalSearchableDropdown
                options={unitStatusOption}
                selected={selectedStatus}
                onSelect={(item) => {
                  setSelectedStatus(item);
                  handleDropdownChange("status", item?.value || "");
                }}
                placeholder="Status"
              />
              {userRole == "ADMIN" && (
                <GlobalSearchableDropdown
                  options={locationOption}
                  selected={selectedLocation}
                  onSelect={(item) => {
                    setSelectedLocation(item);
                    handleDropdownChange("location", item?.value || "");
                  }}
                  placeholder="Location"
                />
              )}

              {/* <Dropdown>
                <Dropdown.Toggle
                  variant="primary"
                  id="dropdown-basic"
                  className="custom-toggle"
                >
                  {selectedStatus ? selectedStatus?.label : "Status"}
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown-menu p-1">
                  {unitStatusOption.map((item) => (
                    <Dropdown.Item
                      className="custom-dropdown-item"
                      key={item.label}
                      onClick={() => {
                        setSelectedStatus(item);
                        handleDropdownChange("status", item?.value);
                      }}
                    >
                      {item?.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown> */}

              {/* <span className="btn btn-group p-0">
                <CustomTooltip title="Table View" arrow placement="top">
                  <Link
                    to="/assets/table-view"
                    className={`btn btn-outline-primary ${
                      type == "table-view" ? "active" : ""
                    }`}
                    style={{ padding: "0.5rem 0.7rem" }}
                  >
                    <FaTableCellsLarge size={16} />
                  </Link>
                </CustomTooltip>
                <CustomTooltip title="Grid View" arrow placement="top">
                  <Link
                    to="/assets/grid-view"
                    className={`btn btn-outline-primary ${
                      type == "grid-view" ? "active" : ""
                    }`}
                    style={{ padding: "0.5rem 0.7rem" }}
                  >
                    <CiGrid42 size={16} />
                  </Link>
                </CustomTooltip>
              </span> */}
            </div>
          </div>
        </div>
        <div>
          <AssetTableView
            error={errorMsg}
            data={data}
            param={param}
            setParam={setParam}
            loading={getLoading}
            total={total}
          />
          {/* {type === "grid-view" ? (
            <AssetGridView
              data={data}
              param={param}
              error={errorMsg}
              setParam={setParam}
              loading={getLoading}
              total={total}
            />
          ) : type === "table-view" ? (
            <AssetTableView
              error={errorMsg}
              data={data}
              param={param}
              setParam={setParam}
              loading={getLoading}
              total={total}
            />
          ) : (
            ""
          )} */}
        </div>
      </Block>
      {/* <AssetAddModal
        visible={assetModal}
        loading={assetAddLoading}
        onSubmit={(data) => createAsset(data)}
        onClose={handleCloseAssetModal}
      /> */}
    </div>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "Employee",
});

export default connect(mapStateToProps)(AssetListPage);
